import script from "./AltroPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AltroPage.vue?vue&type=script&setup=true&lang=ts"

import "./AltroPage.vue?vue&type=style&index=0&id=fa14c17e&lang=css"

const __exports__ = script;

export default __exports__